import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AodIcon(props: IconProps) {
    return <Icon {...props} iconKey={"aod"}/>
}
